export const BACKEND_API_BASE_URL = "https://appliancedeskindia.com/api/";
export const CDN_URL = "https://appliancedeskindia.com/api/";
